(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/utils/token-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/utils/token-utils.js'); 'use strict';

let loginTokenIsHealthy;

function defineMethods(definitions) {
  const {
    LoginTokenTTL
  } = definitions;

  loginTokenIsHealthy = function (timeoutType, timestamp) {
    if (LoginTokenTTL[timeoutType]) {
      return new Date().getTime() < timestamp + LoginTokenTTL[timeoutType];
    }

    return false;
  };
}

if (typeof exports === 'object') {
  defineMethods(require('../definitions.es6'));
} else {
  defineMethods(svs.accountservices.authenticate.definitions);
}

if (typeof exports === 'object') {
  module.exports = {
    loginTokenIsHealthy
  };
} else {
  svs.accountservices.authenticate.utils.token = {
    loginTokenIsHealthy
  };
}
 })(window);